import * as UI from "@iyk/ui"

import { ExclusiveContainer } from "./exclusive-container.tsx"

export const ExclusiveDiscountCode = ({ code, shopUrl }: ExclusiveDiscountCode.Props) => {
  return (
    <ExclusiveContainer>
      <div className="flex flex-col items-center justify-between bshadow bshadow-gray-4 bg-gray-2 h-full p-3">
        <div className="flex flex-col gap-2 justify-center items-center h-full">
          <span className="text-xs-upper text-gray-11">Enjoy 15% off with code</span>
          <span className="font-departure-mono text-[14px] tracking-[12px]">{code}</span>
        </div>
        <div className="flex flex-col gap-1 w-full">
          <UI.CopyToClipboardButton
            kind="shaded"
            size="md"
            textToCopy={code!}
            text={{ idle: "Copy", copied: "Copied!" }}
          />
          <a
            href={shopUrl}
            target="_blank"
            className={UI.classForButton({ kind: "ghost", size: "md" })}
          >
            Shop now
          </a>
        </div>
      </div>
    </ExclusiveContainer>
  )
}

namespace ExclusiveDiscountCode {
  export type Props = {
    code: string
    shopUrl: string
  }
}
